import { createSlice } from "@reduxjs/toolkit";
import {
  saveUserData,
  sendCode,
  saveKariyerData,
  loginUser,
  refreshAccessToken,
  logoutUser,
} from "../actions";

const jwtDecode = window.jwt_decode;
const authSlice = createSlice({
  name: "auth",
  initialState: {
    userId: null,
    data: null,
    email: null,
    accessToken: null,
    isAuthenticated: false,
    loading: false,
    error: null,
  },

  reducers: {
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
      state.isAuthenticated = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveUserData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveUserData.fulfilled, (state, action) => {
        state.loading = false;
        state.email = action.payload.email;
        state.data = action.payload;
      })
      .addCase(saveUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(sendCode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendCode.fulfilled, (state, action) => {
        state.loading = false;
        state.email = action.payload.email;
        state.data = {
          ...(state.data || {}),
          verified: true,
          ...action.payload,
        };
      })
      .addCase(sendCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(saveKariyerData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveKariyerData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = { ...state.data, ...action.payload };
        state.email = action.payload.email;
        state.isAuthenticated = true;

        try {
          const decoded = jwtDecode(action.payload.accessToken);
          state.userId = decoded.userId;
        } catch (error) {
          state.error = "Token geçersiz veya decode edilemedi";
          state.userId = null;
        }
      })
      .addCase(saveKariyerData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.email = action.payload.email;
        state.isAuthenticated = true;

        try {
          const decoded = jwtDecode(action.payload.accessToken);
          state.userId = decoded.userId;
        } catch (error) {
          state.error = "Token geçersiz veya decode edilemedi";
          state.userId = null;
        }
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error =
          typeof action.payload === "string"
            ? action.payload
            : "Giriş başarısız";
        state.isAuthenticated = false;
        state.accessToken = null;
        state.data = null;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.userId = null;
        state.accessToken = null;
        state.isAuthenticated = false;
        state.data = null;
        state.email = null;
        state.error = null;
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(refreshAccessToken.fulfilled, (state, action) => {
        if (!action.payload) return;

        state.isAuthenticated = true;
        state.accessToken = action.payload.accessToken;

        try {
          const decoded = jwtDecode(action.payload.accessToken);
          state.userId = decoded.userId;
        } catch (error) {
          state.error = "Token geçersiz veya decode edilemedi";
          state.userId = null;
        }
      })
      .addCase(refreshAccessToken.rejected, (state) => {
        state.accessToken = null;
        state.isAuthenticated = false;
        state.data = null;
        state.userId = null;
      });
  },
});

export const { setAccessToken } = authSlice.actions;
export default authSlice.reducer;
